export default __webpack_public_path__ + "static/media/pg18-1-1.cd22835f.webp";